var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalFyxdUnrealized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4474_33983)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9017 7.85892C16.4208 8.3781 16.94 8.89731 16.94 8.89731C17.6394 8.19795 17.6429 7.50216 16.9505 6.80989C16.4314 6.29071 16.0854 5.94457 16.0871 5.59668C15.2129 6.47084 15.2093 7.16665 15.9017 7.85892Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M16.0536 12.2069C16.0553 11.859 16.4048 11.5094 16.9295 10.9849C17.6289 10.2855 17.6324 9.58971 16.94 8.89746C16.94 8.89746 16.4156 9.42198 15.8911 9.94647C15.1917 10.6458 15.1882 11.3416 16.0536 12.2069Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2799 1.78928C11.932 1.79106 11.5858 1.44492 11.0667 0.925736C10.3744 0.233465 9.67859 0.237019 8.97925 0.936358C8.97925 0.936358 9.49845 1.45554 10.0176 1.97474C10.7099 2.667 11.4057 2.66346 12.2799 1.78928Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M7.93014 1.98548C8.45466 1.46098 8.97915 0.936471 8.97915 0.936471C8.2869 0.24422 7.59109 0.247754 6.89175 0.947092C6.36724 1.47161 6.01757 1.82128 5.66968 1.82305C6.535 2.68837 7.2308 2.68484 7.93014 1.98548Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M16.0875 5.5964C16.9616 4.72222 16.9651 4.02641 15.9268 2.98803L14.8884 1.94964C13.85 0.911252 13.1542 0.914786 12.28 1.78897C12.6279 1.78721 13.1547 2.29882 13.8394 2.99865L14.8778 4.03705C15.5627 4.73669 16.0892 5.24849 16.0875 5.5964Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.97474 10.0145C1.45554 9.49528 0.936358 8.97607 0.936358 8.97607C0.237019 9.67541 0.233465 10.3712 0.925736 11.0635C1.44492 11.5827 1.79106 11.9288 1.78928 12.2767C2.66346 11.4025 2.667 10.7067 1.97474 10.0145Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1.82255 5.6665C1.8208 6.01442 1.47113 6.36409 0.946612 6.88858C0.247273 7.58794 0.243719 8.28374 0.93599 8.976C0.93599 8.976 1.46048 8.45148 1.985 7.92699C2.68434 7.22763 2.68789 6.53182 1.82255 5.6665Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59668 16.0841C5.94457 16.0824 6.29071 16.4285 6.80989 16.9477C7.50216 17.64 8.19795 17.6365 8.89731 16.9371C8.89731 16.9371 8.3781 16.418 7.85892 15.8986C7.16665 15.2064 6.47084 15.21 5.59668 16.0841Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M9.94625 15.8879C9.42173 16.4123 8.89722 16.937 8.89722 16.937C9.58949 17.6291 10.2853 17.6256 10.9846 16.9262C11.5091 16.4018 11.8588 16.0521 12.2067 16.0504C11.3414 15.185 10.6456 15.1886 9.94625 15.8879Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1.78898 12.2769C0.914796 13.151 0.911242 13.8468 1.94963 14.8852L2.98802 15.9235C4.0264 16.962 4.72221 16.9585 5.59639 16.0842C5.2485 16.086 4.72172 15.5744 4.03704 14.8746L2.99866 13.8362C2.31377 13.1366 1.7872 12.6247 1.78898 12.2769Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6697 1.82282C4.80438 0.957504 4.10857 0.961038 3.05956 2.01005L2.01053 3.05907C0.961526 4.10808 0.957993 4.80389 1.82331 5.66921C1.82509 5.32132 2.34209 4.7893 3.04892 4.09746L4.09795 3.04843C4.80459 2.3564 5.3218 1.82458 5.6697 1.82282Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2073 16.0534C13.0726 16.9187 13.7684 16.9152 14.8174 15.8661L15.8665 14.8172C16.9154 13.7682 16.9191 13.0724 16.0537 12.207C16.052 12.5549 15.535 13.0869 14.828 13.7788L13.779 14.8278C13.0724 15.5198 12.5552 16.0516 12.2073 16.0534Z",
    fill: "#967F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84985 5.56496H8.61824C9.44505 5.56496 10.1665 5.71437 10.7825 6.01172C11.3985 6.31054 11.8765 6.73807 12.2149 7.29577C12.5534 7.85348 12.7226 8.50438 12.7226 9.24997C12.7226 10.4852 12.3559 11.4216 11.6212 12.0562C10.8879 12.6924 9.87849 13.0089 8.59598 13.0089H5.84985V5.56348V5.56496ZM8.75629 11.1568C9.30551 11.1568 9.72708 10.9867 10.0225 10.645C10.3179 10.3047 10.4663 9.83874 10.4663 9.24997C10.4663 8.7248 10.3164 8.2884 10.018 7.93928C9.71966 7.59015 9.30848 7.41708 8.78895 7.41708H8.06159V11.1553H8.75629V11.1568Z",
    fill: "#6B5A36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4474_33983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFyxdUnrealized);
export default __webpack_public_path__ + "static/media/total_fyxd_unrealized.00fb9eaf38481ed28ad6f30a741e9afd.svg";
export { ForwardRef as ReactComponent };